import axios from 'axios'
import { CompleteInfoPayload, LoginFormPayload } from 'src/core/models'

export async function registerUserAPI(payload: any): Promise<any> {
  const { data } = await axios.post('/api/v1/big_register/', payload)
  return data
}

export async function requestRestorePassword(payload: any): Promise<any> {
  const url = '/api/v1/request_restore_code/?is_from_accounts=true'
  const { data } = await axios.post(url, payload)
  return data
}

export async function restorePasswordAPI(payload: any): Promise<any> {
  const { data } = await axios.post('/api/v1/restore_password/', payload)
  return data
}

export async function loginUserAPI(payload: LoginFormPayload): Promise<{ token: string }> {
  const { data } = await axios.post<{ token: string }>('/api/token-auth/', payload)
  return data
}

export async function verifyEmailAPI(code: string): Promise<any> {
  const payload = { verification_code: code }
  const { data } = await axios.post('/api/v1/verify_email/', payload)
  return data
}

export async function completeUserInfoAPI(code: string, payload: CompleteInfoPayload): Promise<number> {
  const payloadData = {
    is_producer: payload.userValues.is_producer,
    reason_to_register: payload.userValues.reason_to_register,
    company_position: payload.userValues.company_position,
    complete_user_info_code: code
  }
  const { data } = await axios.post<{message: string, company_id: number}>(
    '/api/v1/complete_user_info/', payloadData
  )
  return data.company_id
}

export async function validTokenAPI(token: string): Promise<string> {
  const { data } = await axios.post<{ token: string }>('/api/token-verify/', { token })
  return data.token
}

export async function refreshTokenAPI(token: string): Promise<string> {
  const { data } = await axios.post<{ token: string }>('/api/token-refresh/', { token })
  return data.token
}
